import { defineComponent, getCurrentInstance } from "vue";
import AutoTips from "@/components/AutoTips/index.vue";
export default defineComponent({
    components: {
        AutoTips: AutoTips
    },
    props: {},
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var innerLabel = root.$t("playTurbo.authAccount.authDialog.form.dataRange.label");
        var tipsLabel = root.$t("playTurbo.authAccount.authDialog.form.dataRange.tipsLabel");
        return {
            innerLabel: innerLabel,
            tipsLabel: tipsLabel
        };
    }
});
